import { render, staticRenderFns } from "./MultiselectOption.vue?vue&type=template&id=fdf6aa14&scoped=true&"
import script from "./MultiselectOption.vue?vue&type=script&lang=js&"
export * from "./MultiselectOption.vue?vue&type=script&lang=js&"
import style0 from "./MultiselectOption.vue?vue&type=style&index=0&id=fdf6aa14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdf6aa14",
  null
  
)

export default component.exports